__webpack_require__.p = "https://static.spqr.app/bc81e2087022c35393914e6898d6cbf6466b6285/_next/";